import { Component, inject, Input, signal } from '@angular/core';
import { AvatarComponent } from 'app/shared/avatar/avatar.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroPlus } from '@ng-icons/heroicons/outline';
import { HttpClient } from '@angular/common/http';
import { IFriend } from "../model/friends.model";
import { FriendsService } from "../service/friends.service";

@Component({
  selector: 'app-user-card',
  standalone: true,
  imports: [AvatarComponent, IconComponent],
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  providers: [
    provideIcons({
      heroPlus,
    }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class UserCardComponent {
  @Input() user!: IFriend;

  friendsService = inject(FriendsService);
  requestSent = signal(false)

  addFriend(userId: number) {
    this.friendsService.addFriend(userId.toString()).subscribe(() => {
      this.requestSent.set(true);
    })
  }
}
